import { notifications } from '@mantine/notifications';
import { useProfile } from 'init/use-enforce-profile';
import { i18nKeys, useTranslation } from 'locales';
import { z } from 'zod/v4';

import { useCableSubscription } from './use-cable-subscription';

const CustomVariablesMessageSchema = z.object({
  notify_user_id: z.number(),
});

export function useCustomVariablesSubscription() {
  const { t } = useTranslation();
  const profile = useProfile();

  const tellTheCreator = (message: unknown) => {
    const isCreator =
      CustomVariablesMessageSchema.safeParse(message).data?.notify_user_id === profile.id;
    if (isCreator) notifications.show({ message: t(i18nKeys.FORM.CUSTOM_VARIABLES.CREATED) });
  };

  useCableSubscription('CustomVariablesChannel', {
    connected: () => {},
    received: tellTheCreator,
  });
}
